import { Link, NavLink, useNavigate } from "react-router-dom";
import { Search, Upload, Zap, LogOut, Shield } from "lucide-react";
import { useState } from "react";
import { useAuth } from "../lib/auth";

const navItem = ({ isActive }) =>
  `text-sm tracking-wide uppercase font-semibold transition-colors ${
    isActive ? "text-[#FF6B00]" : "text-zinc-400 hover:text-white"
  }`;

export default function Navbar() {
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const { admin, logout } = useAuth();

  const onSearch = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <header
      className="sticky top-0 z-50 glass border-b border-white/5"
      data-testid="navbar"
    >
      <div className="px-4 sm:px-8 lg:px-12 h-16 flex items-center gap-4 lg:gap-8">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 group">
          <div className="relative">
            <Zap className="w-7 h-7 text-[#FF6B00] aura-float" strokeWidth={2.5} />
            <div className="absolute inset-0 blur-md bg-[#FF6B00]/40 rounded-full -z-10 group-hover:bg-[#FFB800]/60 transition-colors" />
          </div>
          <div className="hidden sm:flex flex-col leading-none">
            <span className="text-[10px] uppercase tracking-[0.3em] text-[#FFB800] font-bold">TheSaiyanVictoria</span>
            <span className="text-lg font-black tracking-tight text-white">NEXUS</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-6 ml-4">
          <NavLink to="/" end className={navItem} data-testid="nav-home">Home</NavLink>
          <NavLink to="/shorts" className={navItem} data-testid="nav-shorts">Shorts</NavLink>
          <NavLink to="/library" className={navItem} data-testid="nav-library">Library</NavLink>
        </nav>

        <form onSubmit={onSearch} className="flex-1 max-w-xl mx-auto" data-testid="search-form">
          <div className="relative">
            <Search className="w-4 h-4 text-zinc-500 absolute left-3 top-1/2 -translate-y-1/2" />
            <input
              data-testid="search-input"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search the Nexus..."
              className="w-full pl-9 pr-4 h-10 bg-zinc-900/70 border border-white/10 focus:border-[#FF6B00] focus:ring-1 focus:ring-[#FF6B00] outline-none rounded-full text-sm text-white placeholder:text-zinc-500 transition-colors"
            />
          </div>
        </form>

        <div className="flex items-center gap-2">
          {admin ? (
            <>
              <Link
                to="/admin"
                data-testid="admin-studio-link"
                className="hidden sm:inline-flex items-center gap-2 h-10 px-4 rounded-full bg-zinc-900/70 border border-[#FF6B00]/40 text-[#FFB800] text-xs font-bold uppercase tracking-wider hover:border-[#FF6B00] hover:text-white transition-colors"
              >
                <Upload className="w-4 h-4" /> Studio
              </Link>
              <button
                data-testid="logout-btn"
                onClick={logout}
                className="h-10 w-10 inline-flex items-center justify-center rounded-full bg-zinc-900/70 border border-white/10 text-zinc-400 hover:text-white hover:border-white/30 transition-colors"
                title="Logout"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <Link
              to="/admin/login"
              data-testid="admin-login-link"
              className="inline-flex items-center gap-2 h-10 px-4 rounded-full bg-zinc-900/70 border border-white/10 hover:border-[#FF6B00]/50 text-zinc-300 hover:text-white text-xs font-bold uppercase tracking-wider transition-colors"
            >
              <Shield className="w-4 h-4" /> <span className="hidden sm:inline">Admin</span>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
